<div class="slideout-content">
  <!-- Modal to add Coupon starts-->
  <div
    class="modalsd modal-slide-in sdfade coupon-modal"
    id="modals-slide-in"
  >
    <div class="modal-dialog">
      <form
        class="add-coupon modal-content pt-0"
        (ngSubmit)="(couponForm.form.valid)"
        #couponForm="ngForm"
      >
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="toggleSidebar('coupon-sidebar')"
        >
          ×
        </button>
        <div class="modal-header mb-1">
          <h5 class="modal-title" id="exampleModalLabel" *ngIf="currentCoupon.status != null">Edit Coupon</h5>
          <h5 class="modal-title" id="exampleModalLabel" *ngIf="currentCoupon.status == null">New Coupon</h5>

        </div>

        <div class="modal-body flex-grow-1">
          <div class="row">
            <div class="form-group col-6">
              <label class="form-label" for="coupon-sidebar-name"
                >Name</label
              >
              <input
                type="text"
                class="form-control"
                id="coupon-sidebar-name"
                placeholder="My Coupon"
                name="coupon-name"
                [(ngModel)]="currentCoupon.name"
                [class.error]="couponForm.submitted && FNameRef.invalid"
                #FNameRef="ngModel"
                [disabled]="currentCoupon.status != null && currentCoupon.status != 'pending' "
                required
              />
              <span
                *ngIf="couponForm.submitted && FNameRef.invalid"
                class="invalid-form"
              >
                <small
                  class="form-text text-danger"
                  *ngIf="FNameRef.errors.required"
                  >This field is required!</small
                >
              </span>
            </div>
            <div class="form-group col-6">
              <label class="form-label" for="coupon-sidebar-coupon-code"
                >Promo Code</label
              >
              <input
                type="text"
                class="form-control"
                id="coupon-sidebar-coupon-code"
                placeholder="CODE123"
                name="coupon-code"
                [(ngModel)]="currentCoupon.code"
                [class.error]="couponForm.submitted && FCodeRef.invalid"
                #FCodeRef="ngModel"
                required
                [disabled]="currentCoupon.status != null && currentCoupon.status != 'pending' "

              />
              <span
                *ngIf="couponForm.submitted && FCodeRef.invalid"
                class="invalid-form"
              >
                <small
                  class="form-text text-danger"
                  *ngIf="FCodeRef.errors.required"
                  >This field is required!</small
                >
              </span>
            </div>
            <div class="form-group col-6">
              <label class="form-label" for="coupon-sidebar-startDate"
                >Start Date</label
              >
              <input                
                type="date"
                class="form-control"
                id="coupon-sidebar-startDate"
                name="coupon-sidebar-startDate" 
                [value]="currentCoupon.startDate"
                [(ngModel)]="currentCoupon.startDate"
                [class.error]="couponForm.submitted && FStartRef.invalid"
                required
                #FStartRef="ngModel"
                [disabled]="currentCoupon.status != null && currentCoupon.status != 'pending' "

              />
              <span
                *ngIf="couponForm.submitted && FStartRef.invalid"
                class="invalid-form"
              >
                <small
                  class="form-text text-danger"
                  *ngIf="FStartRef.errors.required"
                  >This field is required!</small
                >
              </span>
            </div>
            <div class="form-group col-6">
              <label class="form-label" for="coupon-sidebar-endDate"
                >End Date</label
              >
              <input                
                type="date"
                class="form-control"
                id="coupon-sidebar-endDate"
                name="coupon-sidebar-endDate" 
                [value]="currentCoupon.endDate"
                [(ngModel)]="currentCoupon.endDate"
                #FEndRef="ngModel"
              />
            </div>
            <div class="form-group col-12">
              <label>Plans</label>
              <!-- Select Multi with Icon -->
              <ng-select
                [items]="plans"
                [multiple]="true"
                [closeOnSelect]="false"
                bindLabel="name"
                bindValue="id"
                name="coupon-plans"
                [disabled]="currentCoupon.status != null && currentCoupon.status != 'pending' "
                [(ngModel)]="currentCoupon.plan_id"
              >
                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                  <span class="ng-value-label">
                    {{ item.title }}
                  </span>
                  <span
                    class="ng-value-icon right"
                    (click)="clear(item)"
                    aria-hidden="true"
                    >×</span
                  >
                </ng-template>
  
                <ng-template ng-header-tmp>
                  <a (click)="selectAll()" class="btn btn-flat-primary btn-sm">
                    Select all
                  </a>
                  <a (click)="unselectAll()" class="btn btn-flat-primary btn-sm">
                    Unselect all
                  </a>
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                    {{ item.title }}
                  </ng-template>
              </ng-select>
              <!--/ Select Multi with Icon -->
            </div>
            <div class="form-group col-12">
              <h5 class="modal-title" id="exampleModalLabel">Setup Discount</h5>
            </div>
            <div class="form-group col-6">
                <label class="form-label" for="coupon-sidebar-setup_amount"
                  >Amount (AUD)</label
                >
                <input 
                  type="number" 
                  min="0" 
                  step="0.1" 
                  id="coupon-sidebar-setup_amount"
                  name="setup_amount" 
                  #FSetupAmountRef="ngModel" 
                  [(ngModel)]="currentCoupon.settings.setup_amount" 
                  placeholder="0.00" 
                  class="form-control"
                  [disabled]="currentCoupon.status != null && currentCoupon.status != 'pending' "
                  required
                >

                 <span
                  *ngIf="couponForm.submitted && FSetupAmountRef.invalid"
                  class="invalid-form"
                >
                  <small
                    class="form-text text-danger"
                    *ngIf="FSetupAmountRef.errors.required"
                    >This field is required!</small
                  >
                </span>
              </div>
            <div class="form-group col-6">
              <label class="form-label" for="coupon-sidebar-setup_percentage"
                >Percentage (%)</label
              >
                <input 
                  type="number" 
                  min="0" 
                  step="0.1" 
                  id="coupon-sidebar-setup_percentage"
                  name="setup_percentage" 
                  #FSetupPercentageRef="ngModel" 
                  [(ngModel)]="currentCoupon.settings.setup_percentage" 
                  placeholder="0.00" 
                  [disabled]="currentCoupon.status != null && currentCoupon.status != 'pending' "
                  class="form-control"
                >

                 <span
                  *ngIf="couponForm.submitted && FSetupPercentageRef.invalid"
                  class="invalid-form"
                >
                  <small
                    class="form-text text-danger"
                    *ngIf="FSetupPercentageRef.errors.required"
                    >This field is required!</small
                  >
                </span>

            </div>

            <div class="form-group col-12">
              <h5 class="modal-title" id="exampleModalLabel">Membership Discount</h5>
            </div>
            <div class="form-group col-6">
                <label class="form-label" for="coupon-sidebar-membership_amount"
                  >Amount (AUD)</label
                >
                <input 
                  type="number" 
                  min="0" 
                  step="0.1" 
                  name="membership_amount" 
                  id="coupon-sidebar-membership_amount"
                  #FMembershipAmountRef="ngModel" 
                  [(ngModel)]="currentCoupon.settings.membership_amount" 
                  placeholder="0.00" 
                  class="form-control"
                  [disabled]="currentCoupon.status != null && currentCoupon.status != 'pending' "
                  required
                >

                 <span
                  *ngIf="couponForm.submitted && FMembershipAmountRef.invalid"
                  class="invalid-form"
                >
                  <small
                    class="form-text text-danger"
                    *ngIf="FMembershipAmountRef.errors.required"
                    >This field is required!</small
                  >
                </span>
              </div>
            <div class="form-group col-6">
              <label class="form-label" for="coupon-sidebar-membership_percentage"
                >Percentage (%)</label
              >
                <input 
                  type="number" 
                  min="0" 
                  step="0.1" 
                  id="coupon-sidebar-membership_percentage"
                  name="membership_percentage" 
                  #FMembershipPercentageRef="ngModel" 
                  [(ngModel)]="currentCoupon.settings.membership_percentage" 
                  placeholder="0.00" 
                  class="form-control"
                  [disabled]="currentCoupon.status != null && currentCoupon.status != 'pending' "
                  required
                >

                 <span
                  *ngIf="couponForm.submitted && FMembershipPercentageRef.invalid"
                  class="invalid-form"
                >
                  <small
                    class="form-text text-danger"
                    *ngIf="FMembershipPercentageRef.errors.required"
                    >This field is required!</small
                  >
                </span>
            </div>   
            
            <div class="form-group col-12 row mt-2" *ngIf="currentCoupon.status != null && currentCoupon.status != 'pending'" style="background-color: lightgray; border-radius: 0px 50px 50px 0px;" >
              <div class="col-8">
                <p style="margin-top: 10px;">Accept New Contracts</p>
              </div>
              <div class="col-4">
                <div class="custom-control custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    (click)="changeStatus(currentCoupon)"
                    id="statusSwitch"
                    [checked]="currentCoupon.status == 'active'"
                  />
                  <label class="custom-control-label" for="statusSwitch" style="margin-top: 10px;">
                    <span class="switch-icon-left"><i data-feather="check"></i></span>
                    <span class="switch-icon-right"><i data-feather="x"></i></span>
                  </label>
                </div>
              </div>
            </div>
          
            <div class="col-12" *ngIf="!loadingButton">
              <button
                type="submit"
                class="btn btn-primary mr-1"
                (click)="submit(couponForm, 'new')"
                rippleEffect
                *ngIf="currentCoupon.status == null"
              >
                Create
              </button>
              <button
                type="submit"
                class="btn btn-primary mr-1"
                (click)="submit(couponForm, 'update')"
                rippleEffect
                *ngIf="currentCoupon.status != null"
              >
                Save
              </button>
              
              <button
                type="reset"
                class="btn btn-outline-secondary"
                (click)="toggleSidebar('coupon-sidebar')"
              >
                Cancel
              </button>
            </div>
            <div class="col-12" *ngIf="loadingButton">
              <button
                class="btn btn-outline-primary"
                type="button"
                disabled
                rippleEffect
              >
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span class="ml-25 align-middle">Saving...</span>
              </button>
            </div>

            <div class="form-group col-12 mt-2 row" *ngIf="currentCoupon.status == 'pending' " style="background-color: lightgray; border-radius: 0px 50px 50px 0px;">
              <div class="col-8">
                <p style="margin-top: 10px;">Publish this coupon?</p>
              </div>
              <div class="col-4" style="align-content: center;">
                <button
                type="submit"
                class="btn btn-primary mr-1"
                (click)="submit(couponForm, 'publish')"
                style="border-radius: 50px;"
                rippleEffect
                >
                Start
               </button>
              </div>
            </div>
          </div>

          
          <!-- <div *ngIf="!alertClose" style="padding: 12px;">
            
            <ngb-alert [type]="'danger'" (closed)="alertClose = !alertClose">
              <h4 class="alert-heading">Error</h4>
              <div class="alert-body">
                {{alert}}
                <button type="button" class="close" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </ngb-alert>
          </div> -->
        </div>
      </form>
    </div>
  </div>
  <!-- Modal to add Coupon Ends-->
</div>
